import React from "react";
import { FilterModal } from "../../Components/FilterModal.jsx";
import Footer from "../../Components/Footer/Footer.js";
import { Navbar2 } from "../../Components/Navbar2/Navbar2.js";
import ProfileMenuSection from "../../Components/ProfileMenuSection.jsx";
import ProfileForm from "../../Components/ProfileForm.jsx";
import MyItemsSection from "../../Components/MyItemsSection.jsx";
import MyWishlistSection from "../../Components/MyWishlistSection.jsx";
import SubscriptionSection from "../../Components/SubscriptionSection.jsx";
import { useEffect } from "react";
import { useReduxStore } from "../../hooks/useReduxStore.js";
import { useNavigate, useLocation } from "react-router-dom";
import FooterNew from "../../Components/LandingNew/FooterNew.jsx";

export default function Profile() {
  const { getState } = useReduxStore();
  const navigate = useNavigate();
  const location = useLocation();
  const { changeSuccess } = getState("AUTH");
  const [open, setOpen] = React.useState(false);
  const [tab, setTab] = React.useState(location?.state?.tab || "my_items");
  const openFilter = () => setOpen(true);
  const closeFilter = () => setOpen(false);
  const onSelectTab = (value) => {
    setTab(value);
  };
  useEffect(() => {
    changeSuccess && navigate("/");
  }, [changeSuccess]);
  return (
    <>
      <Navbar2 />
      <div className="min-h-screen bab-new-bg text-white">
        <section className="h-auto w-full px-4 md:px-8 xl:px-14 py-6 md:py-10 flex flex-col justify-center items-center">
          <div className="mx-auto w-full max-w-7xl">
            <div className="w-full flex flex-col justify-center md:items-start items-center mb-6 md:mb-10">
              <h2 className="text-3xl font-extrabold text-white sm:text-4xl text-center lg:text-left tracking-tight">
                My Account
              </h2>
            </div>

            <div className="w-full lg:grid lg:grid-cols-4 lg:items-start lg:gap-8 xl:gap-10">
              <div className="w-full mb-6 lg:mb-0">
                <ProfileMenuSection
                  setSelectTab={onSelectTab}
                  selectedTab={tab}
                  dark={true}
                />
              </div>

              <div className="w-full lg:col-span-3">
                {tab === "profile" ? (
                  <ProfileForm />
                ) : tab === "my_items" ? (
                  <MyItemsSection />
                ) : tab === "subscription" ? (
                  <SubscriptionSection />
                ) : (
                  <MyWishlistSection />
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      <FooterNew />
      <FilterModal open={open} onOpen={openFilter} onClose={closeFilter} dark={true} />
    </>
  );
}
